import { fetchTraitNavItems } from '../TraitNavRequests'

export const Services = {
    'traits' : fetchTraitNavItems
}